/**
 * AlertGuard - Utilidades de estilos centralizadas
 * Este archivo centraliza todos los colores de severidad y estado
 * para evitar duplicación y garantizar consistencia en toda la UI.
 * 
 * IMPORTANTE: No usar colores amarillos (yellow), ámbar (amber) ni naranja (orange)
 */

// Colores para severidad de alertas y monitores (para clases CSS)
export const SEVERITY_CLASSES = {
  CRITICA: 'bg-red-600 text-white',
  ALTA: 'bg-pink-600 text-white',      // Usando pink en lugar de rose
  MEDIA: 'bg-blue-600 text-white',
  BAJA: 'bg-slate-600 text-white',
};

// Colores para severidad con borde (para badges más suaves)
export const SEVERITY_CLASSES_SOFT = {
  CRITICA: 'bg-red-100 text-red-800 border-red-200',
  ALTA: 'bg-pink-100 text-pink-800 border-pink-200',  // Usando pink
  MEDIA: 'bg-blue-100 text-blue-800 border-blue-200',
  BAJA: 'bg-slate-100 text-slate-800 border-slate-200',
};

// Colores para estados de alertas
export const STATUS_CLASSES = {
  NUEVA: 'bg-red-100 text-red-800',
  TOMADA: 'bg-blue-100 text-blue-800',
  EN_INVESTIGACION: 'bg-indigo-100 text-indigo-800',
  ESCALADA: 'bg-purple-100 text-purple-800',
  CERRADA: 'bg-green-100 text-green-800',
  DESCARTADA: 'bg-gray-100 text-gray-800',
};

// Colores HEX para gráficos (Recharts)
export const SEVERITY_COLORS_HEX = {
  CRITICA: '#ef4444',  // red-500
  ALTA: '#db2777',     // pink-600
  MEDIA: '#3b82f6',    // blue-500
  BAJA: '#64748b',     // slate-500
};

export const STATUS_COLORS_HEX = {
  NUEVA: '#ef4444',
  TOMADA: '#3b82f6',
  EN_INVESTIGACION: '#6366f1',
  ESCALADA: '#a855f7',
  CERRADA: '#10b981',
  DESCARTADA: '#6b7280',
};

// Funciones helper
export const getSeverityColor = (severidad) => {
  return SEVERITY_CLASSES[severidad] || SEVERITY_CLASSES.BAJA;
};

export const getSeverityColorSoft = (severidad) => {
  return SEVERITY_CLASSES_SOFT[severidad] || SEVERITY_CLASSES_SOFT.BAJA;
};

export const getStatusColor = (estado) => {
  return STATUS_CLASSES[estado] || STATUS_CLASSES.NUEVA;
};

export const getSeverityColorHex = (severidad) => {
  return SEVERITY_COLORS_HEX[severidad] || SEVERITY_COLORS_HEX.BAJA;
};

export const getStatusColorHex = (estado) => {
  return STATUS_COLORS_HEX[estado] || STATUS_COLORS_HEX.NUEVA;
};
